import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {IsExternalLoginGuard} from '@shared/guards/is-external-login.guard';
import {
  ExternalInvitationLoginComponent
} from '@app/external-login/pages/external-login/external-invitation-login/external-invitation-login.component';
import {ExternalComponent} from '@app/external-login/pages/external-login/external/external.component';
import {ExternalOpenLoginComponent} from '@app/external-login/pages/external-login/external-open-login/external-open-login.component';

const routes: Routes = [
  {
    path: 'external',
    component: ExternalComponent,
    data: { title: 'openLogin' },
    children: [
      {
        path: 'invitation/externalEmployee',
        component: ExternalInvitationLoginComponent,
        canActivate: [IsExternalLoginGuard],
        data: {
          title: 'openLogin',
        }
      },
      {
        path: 'openLogin/:companyId',
        component: ExternalOpenLoginComponent,
        canActivate: [],
        data: {
          title: 'openLogin',
        }
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExternalLoginRoutingModule { }
